import { GET } from 'shared/utils/ajax';

/**
 * 팝송 추천 단어 조회
 * @param {string} upc
 */
export const getSongRecommendWords$ = upc =>
  GET(`/rest/media/recommendWords/${upc}`);
